import api from './api';
const PRODUCT_KEY = process.env.REACT_APP_PRODUCT_KEY;

export const updateAccountOnboardingStep = async (accountId, step) => {
  await api.patch(`/accounts/${accountId}`, { onboarding_step: step, product_key: PRODUCT_KEY });
};

/**
 * Persiste classificação do onboarding (tipo + faixa + etapa) num único PATCH.
 * Campos opcionais são omitidos para passos intermediários.
 * `accepted_segment_at` só no PATCH final (tipo + faixa / start_profiles_count).
 * Nota: a API usa o typo legado `type_descrition`.
 */
export const updateAccountOnboardingClassification = async (
  accountId,
  { typeDescription, startProfilesCount, onboardingStep, language, couponCode },
) => {
  const payload = {
    onboarding_step: onboardingStep,
    product_key: PRODUCT_KEY,
  };

  if (typeDescription !== undefined) {
    payload.type_descrition = typeDescription;
  }

  if (startProfilesCount !== undefined) {
    payload.start_profiles_count = startProfilesCount;
    payload.accepted_segment_at = new Date();
  }

  if (language !== undefined) {
    payload.language = language;
  }

  if (couponCode !== undefined) {
    payload.coupon_code = couponCode;
  }

  return api.patch(`/accounts/${accountId}`, payload);
};

export const updateAccountStartProfiles = async (accountId, {
  startProfilesCount,
  language,
  couponCode,
}) => {
  return await api.patch(`/accounts/${accountId}`, {
    start_profiles_count: startProfilesCount,
    language,
    coupon_code: couponCode,
    product_key: PRODUCT_KEY,
  });
};

export const updateAccountOnboardingGoals = async (accountId, goals) => {
  return await api.patch(`/accounts/${accountId}`, {
    onboarding_goals: goals,
    accepted_onboarding_at: new Date(),
    product_key: PRODUCT_KEY,
  });
};

export const updateAccountOnboardingWhatsapp = async (accountId, { phoneCode, phoneNumber }) => {
  return await api.patch(`/accounts/${accountId}`, {
    phone_code: phoneCode,
    phone_number: phoneNumber,
    phone_receive_whatsapp: true,
    product_key: PRODUCT_KEY,
  });
};
